<div [@enterAnimation]  *ngIf="message"  class="system-error" [ngClass]="type">
    <img (click)="close();" src="/assets/images/xclose-bright.svg">
    <span>{{message}}</span>
</div>
